// extracted by mini-css-extract-plugin
module.exports = {"companyHero":"CompanyHero-module--company-hero--3X4IS"};